// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__mHRdD","errors":"Errors_errors__1j4y0"};